var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 471 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 0C10.745 0 0 10.745 0 24v119c0 13.255 10.745 24 24 24h347c13.255 0 24-10.745 24-24V24c0-13.255-10.745-24-24-24H24zm340.727 100.373c9.791 0 17.728-7.918 17.728-17.686 0-9.769-7.937-17.687-17.728-17.687C354.937 65 347 72.918 347 82.687c0 9.768 7.937 17.686 17.727 17.686z",
    className: "primary",
    fill: "#DB1622"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 378,
    height: 146,
    rx: 23,
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.449 104.406c-3.751 0-7.211-.87-10.382-2.61-3.132-1.779-5.626-4.234-7.482-7.366-1.817-3.17-2.726-6.728-2.726-10.672 0-3.944.909-7.482 2.726-10.614 1.856-3.132 4.35-5.568 7.482-7.308 3.171-1.779 6.631-2.668 10.382-2.668 3.789 0 7.25.89 10.382 2.668 3.171 1.74 5.665 4.176 7.482 7.308 1.817 3.132 2.726 6.67 2.726 10.614 0 3.944-.909 7.501-2.726 10.672-1.817 3.132-4.311 5.587-7.482 7.366-3.132 1.74-6.593 2.61-10.382 2.61zm0-5.742c2.668 0 5.046-.6 7.134-1.798 2.088-1.237 3.712-2.977 4.872-5.22 1.199-2.281 1.798-4.91 1.798-7.888 0-2.977-.599-5.587-1.798-7.83-1.16-2.243-2.784-3.963-4.872-5.162-2.088-1.199-4.466-1.798-7.134-1.798s-5.046.6-7.134 1.798c-2.088 1.199-3.731 2.92-4.93 5.162-1.16 2.243-1.74 4.853-1.74 7.83 0 2.977.58 5.607 1.74 7.888 1.199 2.243 2.842 3.983 4.93 5.22 2.088 1.199 4.466 1.798 7.134 1.798zm50.818-34.974v5.394h-17.11v11.89h13.34v5.394h-13.34V104h-6.612V63.69h23.722zm12.74 5.336v11.832h13.92v5.394h-13.92v12.354h15.66V104h-22.272V63.632h22.272v5.394h-15.66zM219.749 104l-9.28-16.124h-5.046V104h-6.612V63.69h13.92c3.093 0 5.703.541 7.83 1.624 2.165 1.083 3.77 2.533 4.814 4.35 1.083 1.817 1.624 3.847 1.624 6.09 0 2.63-.773 5.027-2.32 7.192-1.508 2.127-3.847 3.577-7.018 4.35L227.637 104h-7.888zm-14.326-21.402h7.308c2.475 0 4.331-.619 5.568-1.856 1.276-1.237 1.914-2.9 1.914-4.988 0-2.088-.619-3.712-1.856-4.872-1.237-1.199-3.113-1.798-5.626-1.798h-7.308v13.514zm56.076-18.908v5.394h-10.73V104h-6.612V69.084h-10.788V63.69h28.13zm30.999 32.074H275.62l-2.9 8.236h-6.902l14.442-40.368h7.656L302.358 104h-6.96l-2.9-8.236zm-1.856-5.394l-6.554-18.734-6.612 18.734h13.166z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383 83c0 9.941-8.059 18-18 18s-18-8.059-18-18 8.059-18 18-18 18 8.059 18 18z",
    stroke: "#DCBA42",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.502 70.724c3.352 1.465 7.998 11.276 0 17.276M381 82c40.08-12.33 82.966-42.761 87.5-26 4.534 16.761-43.642 27.638-87.5 26z",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 235.5 235.5)",
    d: "M0 0h167v471H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.316d8305ad3e7e5db4e718ebe03e26e2.svg";
export { ForwardRef as ReactComponent };